interface InsightsParams {
  projectId: string
}

interface InsightParams extends InsightsParams {
  insightId: number
}

const endpoints = {
  getInsights: ({ projectId }: InsightsParams): string => {
    return `api/v2.4/projects/${projectId}/insights`
  },
  createInsight: ({ projectId }: InsightsParams): string => {
    return `api/v2.4/projects/${projectId}/insights`
  },
  getInsight: ({ projectId, insightId }: InsightParams): string => {
    return `api/v2.4/projects/${projectId}/insights/${insightId}`
  },
}

export default endpoints
